document.querySelectorAll('[data-toggle-password]').forEach((button) => {
    button.addEventListener('click', () => {
        const input = document.getElementById(button.dataset.togglePassword);
        if (!input) {
            return;
        }

        const reveal = input.type === 'password';
        input.type = reveal ? 'text' : 'password';
        button.setAttribute('aria-label', reveal ? 'Hide password' : 'Show password');
        button.classList.toggle('text-heading', reveal);
    });
});

const tabs = document.querySelectorAll('[data-auth-tab]');
const panels = document.querySelectorAll('[data-auth-panel]');

function showAuthTab(name) {
    tabs.forEach((tab) => {
        const active = tab.dataset.authTab === name;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.classList.toggle('bg-card', active);
        tab.classList.toggle('text-heading', active);
        tab.classList.toggle('shadow-sm', active);
        tab.classList.toggle('text-muted', !active);
    });

    panels.forEach((panel) => {
        panel.hidden = panel.dataset.authPanel !== name;
    });

    const url = new URL(window.location.href);
    url.searchParams.set('tab', name);
    window.history.replaceState({}, '', url);
}

tabs.forEach((tab) => {
    tab.addEventListener('click', () => showAuthTab(tab.dataset.authTab));
});

document.querySelectorAll('[data-auth-switch]').forEach((link) => {
    link.addEventListener('click', (event) => {
        event.preventDefault();
        showAuthTab(link.dataset.authSwitch);
    });
});

document.querySelectorAll('[data-date-mask]').forEach((input) => {
    input.addEventListener('input', () => {
        const digits = input.value.replace(/\D/g, '').slice(0, 8);
        const parts = [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4)].filter(Boolean);
        input.value = parts.join('/');
    });
});
